'use strict';

const getStoredTheme = () => localStorage.getItem('theme');
const setStoredTheme = (theme) => localStorage.setItem('theme', theme);
const removeStoredTheme = () => localStorage.removeItem('theme');

// Override the server-rendered color-scheme media queries so that a manually
// selected theme can take precedence over the operating system preference.
const setPictureColorScheme = (theme) => {
	document.querySelectorAll('picture source[data-picture-color-scheme]').forEach((source) => {
		source.media = source.dataset.pictureColorScheme === theme ? 'all' : 'not all';
	});
};

// Gets the theme from storage or the media query
const getPreferredTheme = () => {
	const storedTheme = getStoredTheme();
	if (storedTheme) {
		return storedTheme;
	}

	return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

// Set the data attribute
const setTheme = (theme) => {
	document.documentElement.setAttribute('data-color-scheme', theme);
	setPictureColorScheme(theme);

	// Dispatch a custom event that we can use to react to the theme change
	const event = new CustomEvent('colorModeChange', { detail: theme });
	document.dispatchEvent(event);
};

/**
 * Event Listeners
 */

// React to changes to the prefers-color-scheme media query
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
	removeStoredTheme();
	setTheme(getPreferredTheme());
});

// React to changes to the toggle
window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-color-scheme-toggle]').forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const targetTheme = document.documentElement.getAttribute('data-color-scheme') === 'dark' ? 'light' : 'dark';
			setStoredTheme(targetTheme);
			setTheme(targetTheme);
		});
	});
});

// Fallback in case the critical inline script did not run.
if (!document.documentElement.getAttribute('data-color-scheme')) {
	setTheme(getPreferredTheme());
}

setPictureColorScheme(document.documentElement.getAttribute('data-color-scheme') || getPreferredTheme());

window.getColorScheme = () => document.documentElement.getAttribute('data-color-scheme');
